import './IdCardCss.css'


export default function IdCard() {
    return (
    <section className="main-container">
        <div className="id-card">
            <div className="id-card-photo">
                <img src="https://i.pinimg.com/564x/c6/08/3e/c6083e3c970edf34e4f7b89ec071437e.jpg" alt="Photo" />
            </div>
            <div className="id-card-details">
                <div className="id-card-name">Monkey D Loffy</div>
                <div className="id-card-job-title">Software Engineer</div>
                <div className="id-card-company">One peice</div>
                <div className="id-card-email">loffy@gmail.com</div>
                <div className="id-card-phone">+1 (123) 456-7890</div>
                <div className="id-card-website">https://onepeice.com</div>
                <div className="id-card-address">12345 Street Name, City, Country</div>
            </div>
        </div>
    </section>
    );
};